<template>
  <div>
    <v-list-item @click.stop="onDialog" link v-if="!hideTitleForm">
      <v-list-item-title>デート</v-list-item-title>
    </v-list-item>
    <v-dialog v-model="dialogForm" persistent max-width="800px">
      <v-card>
        <v-form ref="form">
          <v-card-title><span class="headline">デート</span></v-card-title>
          <v-divider></v-divider>
          <v-card-text class="container grid-list-md body-content-dialog">
            <v-layout wrap>
              <v-flex xs6>
                <v-select v-model="dataDateArrangement.option.shift" :items="shifts" :rules="rules.shift"
                  item-text="label" item-value="value" label="ｼﾌﾄ" @change="openDialogCV"
                  :readonly="dataDateArrangement.option.shift == 1"></v-select>
              </v-flex>
              <v-flex xs6>
                <v-select :items="kinds" v-model="dataDateArrangement.kind" :rules="rules.kind" @change="changeKind"
                  item-text="label" item-value="value" label="取組区分">
                  <template v-slot:item="{ item, attrs, on }">
                    <v-list-item v-on="on" v-bind="attrs" :class="{'d-none': item.value == 1007 }">
                        <v-list-item-title>
                          {{ item.label }}
                        </v-list-item-title>
                    </v-list-item>
                  </template>
                </v-select>
                <!-- <v-text-field v-model="dataDateArrangement.kind" readonly label="取組区分"> -->
                <!-- </v-text-field> -->
              </v-flex>
              <template v-if="dataDateArrangement.status == statusPlan">
                <v-flex xs6>
                  <v-select v-model="dataDateArrangement.status" :items="status" :rules="rules.status" item-text="text"
                    item-value="value" label="状態"></v-select>
                </v-flex>
                <v-flex xs6 class="d-flex align-center">
                  <v-checkbox v-model="dataDateArrangement.option.verTel" label="日時確認済"></v-checkbox>
                </v-flex>
              </template>
              <template v-else-if="dataDateArrangement.status == statusImplementation">
                <v-flex xs3>
                  <v-select v-model="dataDateArrangement.status" :items="status" :rules="rules.status" item-text="text"
                    item-value="value" label="状態"></v-select>
                </v-flex>
                <v-flex xs3 class="d-flex align-center">
                  <v-checkbox v-model="dataDateArrangement.option.follTel" label="フォローTEL済"></v-checkbox>
                </v-flex>
                <v-flex xs3>
                  <v-select :items="result" item-text="label" item-value="value" label="結果"
                    v-model="dataDateArrangement.option.result"></v-select>
                </v-flex>

                <v-flex xs3 class="d-flex align-center" v-if="dataDateArrangement.option.result != null">
                  <v-checkbox v-model="dataDateArrangement.option.resTel" label="結果報告TEL済"></v-checkbox>
                </v-flex>
              </template>
              <template v-else>
                <v-flex xs6>
                  <v-select v-model="dataDateArrangement.status" :items="status" :rules="rules.status" item-text="text"
                    item-value="value" label="状態"></v-select>
                </v-flex>
              </template>
              <v-flex xs6>
                <v-menu :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px"
                  min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="computedDateFormatted" :rules="rules.target_date" readonly label="日付"
                      append-icon="mdi-calendar" persistent-hint v-bind="attrs" v-on="on" width="120px">
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="dataDateArrangement.target_date"
                    :day-format="(target_date) => new Date(target_date).getDate()" no-title></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6>
                <v-select v-model="dataDateArrangement.counselor_id"
                  :items="customer && customer.shop_id !== null ? validCounselors : counselors"
                  :rules="rules.counselor"
                  item-text="name" item-value="id" label="担当者" @change="onCounselorSelected">
                  <template v-slot:item="{ item, attrs, on }">
                    <v-list-item v-on="on" v-bind="attrs" :class="{'d-none': !(item.resignation_date == null || moment(item.resignation_date).format('YYYY/MM/DD') > moment().format('YYYY/MM/DD'))}">
                        <v-list-item-title>
                          {{ item.name }}
                        </v-list-item-title>
                    </v-list-item>
                  </template>
                </v-select>
              </v-flex>
              <!-- target_time -->
              <v-flex xs6>
                <v-dialog ref="dialog1" v-model="timePick['target_time']"
                  :return-value.sync="dataDateArrangement.target_time" persistent width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="dataDateArrangement.target_time" :rules="rules.target_time" label="実施時刻"
                      readonly v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-time-picker v-if="timePick['target_time']" v-model="dataDateArrangement.target_time" full-width
                    scrollable format="24hr" @change="changeTimeStart($event)">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="timePick['target_time'] = false">
                      Cancel
                    </v-btn>
                    <v-btn text color="primary" @click="saveTimeStart">
                      OK
                    </v-btn>
                  </v-time-picker>
                </v-dialog>
              </v-flex>
              <!-- end at -->
              <v-flex xs6>
                <v-dialog ref="dialog2" v-model="timePick['target_time_end']"
                  :return-value.sync="dataDateArrangement.target_time_end" persistent width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="dataDateArrangement.target_time_end" :rules="rules.target_time_end"
                      label="終了時刻" readonly v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-time-picker v-if="timePick['target_time_end']" v-model="dataDateArrangement.target_time_end"
                    :min="minTime" full-width scrollable format="24hr">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="timePick['target_time_end'] = false">
                      Cancel
                    </v-btn>
                    <v-btn text color="primary" @click="$refs.dialog2.save(dataDateArrangement.target_time_end)">
                      OK
                    </v-btn>
                  </v-time-picker>
                </v-dialog>
              </v-flex>
              <!-- phone -->
              <v-flex xs6>
                <v-text-field v-model="phoneMale" name="male" :rules="rules.phoneMale" @blur="apiPhone($event)"
                  ref="phoneMale" type="text" label="携帯番号(男性会員)" :readonly="customerMaleFromHistory">
                </v-text-field>
              </v-flex>
              <!-- name -->
              <v-flex xs6>
                <v-autocomplete v-model="nameMale" :rules="rules.nameMale" label="会員名(男性会員)"
                  @keydown="focusCustomerName" @update:search-input="debounceMale" @input="inputCustomerNameMale"
                  :items="itemFamilyNameMales" @blur="blurNameMale"
                  :readonly="customerMaleFromHistory"></v-autocomplete>
              </v-flex>
              <!-- phone -->
              <v-flex xs6>
                <v-text-field v-model="phoneFemale" name="female" :rules="rules.phoneFemale" @blur="apiPhone($event)"
                  ref="phoneFemale" type="text" label="携帯番号(女性会員)" :readonly="customerFeMaleFromHistory">
                </v-text-field>
              </v-flex>
              <!-- name -->
              <v-flex xs6>
                <v-autocomplete v-model="nameFemale" :rules="rules.nameFemale" label="会員名(女性会員)"
                  @keydown="focusCustomerName" @update:search-input="debounceFemale" @input="inputCustomerNameFemale"
                  :items="itemFamilyNameFemales" @blur="blurNameFemale"
                  :readonly="customerFeMaleFromHistory"></v-autocomplete>
              </v-flex>
              <!-- booth no -->
              <v-flex xs6>
                <v-select v-model="dataDateArrangement.booth_no_id" :items="validBoothNos"
                  item-text="booth_no" item-value="id" label="ブース№"></v-select>
              </v-flex>
              <!-- note -->
              <v-flex xs12>
                <v-textarea 
                  label="メモ" 
                  v-model="dataDateArrangement.note" 
                  :rules="rules.note"
                  :rows="3"
                  @input="onMemoInput"
                  @click="onMemoClick"
                  ref="memoTextarea"
                  class="memo-textarea"
                >
                </v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn width="132" class="info" @click="checkHistory">登録</v-btn>
            <v-btn width="132" class="secondary" @click="closeDialog">戻る</v-btn>
            <v-btn width="132" class="error" v-if="typeSubmit == 'update'" @click="resetForm">削除</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <CompanyVisit :shop_id="shop_id" :date="date" :dialogCV="dialogCV" @closeDialogCV="closeDialogCV"
      :boothNos="boothNos" :counselors="counselors" :hideTitle="true" :valueKindForShift="kindShift" />
    
    <!-- Memo Modal -->
    <v-dialog v-model="memoDialog" max-width="600px">
      <v-card>
        <v-card-title class="headline">
          メモ編集
        </v-card-title>
        <v-card-text>
          <v-textarea
            v-model="memoContent"
            label="メモ"
            :rules="rules.note"
            :auto-grow="true"
            :min-rows="5"
            :max-rows="15"
            ref="memoModalTextarea"
            class="memo-modal-textarea"
            placeholder="メモを入力してください..."
            @input="adjustMemoModalSize"
            @focus="adjustMemoModalSize"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="cancelMemoModal">
            キャンセル
          </v-btn>
          <v-btn color="blue darken-1" text @click="confirmMemoModal">
            確認
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import CUSTOMER from "@/consts/customer.js";
import moment from "moment";
import { required, inArray, date, phone, digits, max, isSelectedCounselor } from '@/utilities/validation.js';
import CompanyVisit from "./CompanyVisit.vue";
import constants from '@/consts/constants.js'
import Swal from 'sweetalert2';

export default {
  name: "DateMatchking",
  components: { CompanyVisit },
  props: ['date', 'boothNos', 'counselors', 'shop_id', 'historyData', 'showFormDateMatching', 'hideTitleForm', 'valueKindForForm', 'customer', 'isLedgerScreen'],

  data: function () {
    const shifts = CUSTOMER.SHIFTS
    const kinds = [
      { label: CUSTOMER.EXEC_KIND.NAME.DATE, value: CUSTOMER.EXEC_KIND.VAL.DATE },
      { label: CUSTOMER.EXEC_KIND.NAME.DATE2, value: CUSTOMER.EXEC_KIND.VAL.DATE2 },
      { label: CUSTOMER.EXEC_KIND.NAME.DATE3, value: CUSTOMER.EXEC_KIND.VAL.DATE3 },
      { label: CUSTOMER.EXEC_KIND.NAME.OTHER_BRANCH_DATE, value: CUSTOMER.EXEC_KIND.VAL.OTHER_BRANCH_DATE },
      { label: CUSTOMER.EXEC_KIND.NAME.VISIT_TO_REPORT, value: CUSTOMER.EXEC_KIND.VAL.VISIT_TO_REPORT },
    ]
    const statusPayments = CUSTOMER.STATUS_PAYMENTS
    const resultTELs = CUSTOMER.RESULT_TELS
    const statusPlan = CUSTOMER.STATUS.getValue('予定')
    const statusImplementation = CUSTOMER.STATUS.getValue('実施')
    const result = CUSTOMER.RESULT

    return {
      // validate
      rules: {
        shift: [
          (v) => required(v),
          (v) => inArray(v, shifts.map(item => item.value)),
        ],
        kind: [
          (v) => required(v),
          (v) => inArray(v, kinds.map(item => item.value)),
        ],
        status: [
          (v) => required(v),
          (v) => inArray(v, this.status.map(item => item.value)),
        ],
        statusPayment: [
          (v) => required(v),
          (v) => inArray(v, statusPayments.map(item => item.value)),
        ],
        resultTEL: [
          (v) => required(v),
          (v) => inArray(v, resultTELs.map(item => item.value)),
        ],
        target_date: [
          (v) => required(v),
          (v) => date(v),
        ],
        counselor: [
          (v) => required(v),
        ],
        target_time: [
          (v) => required(v),
        ],
        target_time_end: [
          (v) => required(v),
        ],
        phoneMale: [
          (v) => required(v),
          (v) => phone(v),
          (v) => digits(v, 13),
        ],
        nameMale: [
          (v) => required(v),
        ],
        phoneFemale: [
          (v) => required(v),
          (v) => phone(v),
          (v) => digits(v, 13),
        ],
        nameFemale: [
          (v) => required(v),
        ],
        boothNo: [
          () => isSelectedCounselor(this.dataDateArrangement.counselor_id),
          (v) => required(v),
          (v) => inArray(v, this.validBoothNos.map(item => item.id)),
        ],
        shop: [
          (v) => required(v),
        ],
        note: [
          (v) => max(v, 1000),
        ],
        result: [
          (v) => required(v),
        ],
      },

      dataDateArrangement: {
        kind: null,
        status: statusPlan,
        target_date: this.date,
        counselor_id: "",
        target_time: "",
        target_time_end: "",
        male_customer_id: "",
        female_customer_id: "",
        booth_no_id: "",
        note: "",
        type: constants.TYPE_FORM.DATE_INPUT,

        option: {
          // isPay: false,
          result: null,
          verTel: false,
          follTel: false,
          resTel: false,
          shift: 0,
        },
      },
      shifts,
      kinds,
      status: CUSTOMER.STATUS.LIST,
      statusPayments,
      resultTELs,
      timePick: [],
      isFamilyName: false,
      phoneMale: "",
      phoneMaleOld: "",
      nameMale: "",
      nameMaleOld: "",
      customerMales: '',
      itemFamilyNameMales: [],
      phoneFemale: "",
      phoneFemaleOld: "",
      nameFemale: "",
      nameFemaleOld: "",
      customerFemales: '',
      itemFamilyNameFemales: [],
      dialogForm: false,
      dialogCV: false,
      typeSubmit: null,
      addTimeWithKind: 0,
      minTime: null,
      kindShift: 102, //Kind SHIFT_CONTRACT
      timer: null,
      isValueForm: [31, 32, 33],
      customerMaleFromHistory: false,
      customerFeMaleFromHistory: false,
      statusPlan,
      statusImplementation,
      result,
      validBoothNos: [],
      validCounselors: [],
      moment: moment,
      // memo modal state
      memoDialog: false,
      memoContent: '',
      suppressMemoOpen: false,
    }
  },

  mounted() {
    // this.getTimeAddFromKind()
  },
  computed: {

    computedDateFormatted() {
      return this.dataDateArrangement.target_date ? this.formatDate(this.dataDateArrangement.target_date) : this.formatDate(this.date)
    },
  },

  watch: {
    phoneMale: function (newPhone) {
      if (newPhone) {
        const phone = newPhone.replace(/\D/g, '')
        const firstBlockPhone = phone.substring(0, 3)
        const secondBlockPhone = phone.substring(3, 7)
        const thirdBlockPhone = phone.substring(7)

        let formatPhone = `${firstBlockPhone}`;
        if (secondBlockPhone.length > 0) {
          formatPhone += `-${secondBlockPhone}`;
        }
        if (thirdBlockPhone.length > 0) {
          formatPhone += `-${thirdBlockPhone}`;
        }

        this.phoneMale = formatPhone;
      }
    },
    phoneFemale: function (newPhone) {
      if (newPhone) {
        const phone = newPhone.replace(/\D/g, '')
        const firstBlockPhone = phone.substring(0, 3)
        const secondBlockPhone = phone.substring(3, 7)
        const thirdBlockPhone = phone.substring(7)

        let formatPhone = `${firstBlockPhone}`;
        if (secondBlockPhone.length > 0) {
          formatPhone += `-${secondBlockPhone}`;
        }
        if (thirdBlockPhone.length > 0) {
          formatPhone += `-${thirdBlockPhone}`;
        }

        this.phoneFemale = formatPhone;
      }
    },
    showFormDateMatching: function (newDialog) {
      this.dialogForm = newDialog
      this.validCounselors = this.counselors
    },
    historyData: function (newDataHistory) {
      if (newDataHistory.type == constants.TYPE_FORM.DATE_INPUT && this.valueKindForForm.length == 0) {
        this.dataDateArrangement.kind = newDataHistory.kind
        this.dataDateArrangement.target_date = this.formatDateSlash(newDataHistory.target_date)
        this.dataDateArrangement.target_time = newDataHistory.target_time
        this.dataDateArrangement.target_time_end = newDataHistory.target_time_end
        this.dataDateArrangement.customer_id = newDataHistory.customer_id
        this.dataDateArrangement.booth_no_id = newDataHistory.booth_no_id
        this.dataDateArrangement.counselor_id = newDataHistory.counselor_id
        this.dataDateArrangement.note = newDataHistory.note
        // this.dataDateArrangement.option = newDataHistory.option
        this.dataDateArrangement.option.counterpart_history_id = newDataHistory.option.counterpart_history_id
        this.dataDateArrangement.option.female_customer_id = newDataHistory.option.female_customer_id
        this.dataDateArrangement.option.male_customer_id = newDataHistory.option.male_customer_id
        this.dataDateArrangement.option.match_reserve_id = newDataHistory.option.match_reserve_id
        this.dataDateArrangement.option.result = newDataHistory.option.result
        this.dataDateArrangement.option.verTel = newDataHistory.option.verTel
        this.dataDateArrangement.option.follTel = newDataHistory.option.follTel
        this.dataDateArrangement.option.resTel = newDataHistory.option.resTel
        this.phoneMale = newDataHistory.male_customer.phone_number
        this.nameMale = newDataHistory.male_customer.family_name + newDataHistory.male_customer.given_name
        this.nameMaleOld = this.nameMale
        this.itemFamilyNameMales = [this.nameMale]
        this.dataDateArrangement.male_customer_id = newDataHistory.male_customer.id
        // this.dataDateArrangement.option.isPay = newDataHistory.option.isPay
        this.dataDateArrangement.status = newDataHistory.status
        this.phoneFemale = newDataHistory.female_customer.phone_number
        this.nameFemale = newDataHistory.female_customer.family_name + newDataHistory.female_customer.given_name
        this.nameFemaleOld = this.nameFemale
        this.itemFamilyNameFemales = [this.nameFemale]
        this.dataDateArrangement.female_customer_id = newDataHistory.female_customer.id
        this.typeSubmit = 'update'
        // this.changeKind()
        this.getTimeAddWithKind(this.dataDateArrangement.kind)
        this.validBoothNos = this.boothNos
      }
    },
    valueKindForForm: function (newValueKindForForm) {
      if (newValueKindForForm) {
        this.phoneMale = ''
        this.nameMale = ''
        this.nameFemale = ''
        this.phoneFemale = ''
        this.dataDateArrangement = {
          kind: newValueKindForForm,
          status: this.statusPlan,
          target_date: this.date,
          counselor_id: "",
          target_time: "",
          target_time_end: "",
          male_customer_id: "",
          female_customer_id: "",
          booth_no_id: "",
          note: "",
          type: constants.TYPE_FORM.DATE_INPUT,
          option: {
            // isPay: false,
            result: null,
            verTel: false,
            follTel: false,
            resTel: false,
            shift: 0
          },
        }
        if (this.customer.id != CUSTOMER.NOT_MEMBER_CUSTOMER && this.customer.id != CUSTOMER.MEMBER_CONNECT) {
          if (this.customer.gender == CUSTOMER.GENDER.VAL.MALE) {
            this.itemFamilyNameMales = [this.customer.family_name + this.customer.given_name]
            this.phoneMale = this.customer.phone_number
            this.nameMale = this.customer.family_name + this.customer.given_name
            this.customerMaleFromHistory = true
          } else {
            this.itemFamilyNameFemales = [this.customer.family_name + this.customer.given_name]
            this.phoneFemale = this.customer.phone_number
            this.nameFemale = this.customer.family_name + this.customer.given_name
            this.customerFeMaleFromHistory = true
          }
        }
        this.typeSubmit = ''
        this.changeKind()
        // this.getTimeAddFromKind()
        if (this.isValueForm.includes(newValueKindForForm)) {
          this.$refs.form.resetValidation()
        }
      }
    },
    date: function (newDate) {
      if (newDate) {
        this.dataDateArrangement.target_date = newDate
      }
    },
  },

  methods: {
    blurNameMale() {
      this.itemFamilyNameMales = [this.nameMaleOld]
      this.nameMale = this.nameMaleOld
      this.isFamilyName = false;
    },
    blurNameFemale() {
      this.itemFamilyNameFemales = [this.nameFemaleOld]
      this.nameFemale = this.nameFemaleOld
      this.isFamilyName = false;
    },

    // debounce
    async debounceMale(e, timeout = 300) {
      clearTimeout(this.timer);
      const gender = 1
      this.timer = setTimeout(() => { this.searchInputCustomerName(e, gender) }, timeout);
    },
    async debounceFemale(e, timeout = 300) {
      clearTimeout(this.timer);
      const gender = 2
      this.timer = setTimeout(() => { this.searchInputCustomerName(e, gender) }, timeout);
    },

    // forcus
    focusCustomerName() {
      this.isFamilyName = true;
    },

    // search input customer name
    async searchInputCustomerName(e, gender) {
      if (!this.isFamilyName || e == null || e == '') {
        return
      }

      let url = '/api/v1/customer/by-name/' + e + '?gender=' + gender
      const response = await this.$axios.get(url)
      if (gender == 1) {
        this.customerMales = response.data.customers
        this.itemFamilyNameMales = this.customerMales.map(item => {
          return item.family_name + item.given_name + ' (' + item.family_name_kana + item.given_name_kana + ')'
        })
      } else {
        this.customerFemales = response.data.customers
        this.itemFamilyNameFemales = this.customerFemales.map(item => {
          return item.family_name + item.given_name + ' (' + item.family_name_kana + item.given_name_kana + ')'
        })
      }
    },

    // input customer
    async inputCustomerNameMale(e) {
      if (e == null) {
        return
      }

      const customers = this.customerMales.find(item => e == item.family_name + item.given_name + ' (' + item.family_name_kana + item.given_name_kana + ')')

      if (Object.keys(customers).length > 0) {
        this.itemFamilyNameMales = [customers.family_name + customers.given_name]
        this.nameMale = await customers.family_name + customers.given_name
        this.nameMaleOld = await customers.family_name + customers.given_name
        this.phoneMale = customers.phone_number;
        this.phoneMaleOld = customers.phone_number
        this.dataDateArrangement.male_customer_id = customers.id
      }

      this.isFamilyName = false;
    },
    async inputCustomerNameFemale(e) {
      const customers = this.customerFemales.find(item => e == item.family_name + item.given_name + ' (' + item.family_name_kana + item.given_name_kana + ')')

      if (Object.keys(customers).length > 0) {
        this.itemFamilyNameFemales = [customers.family_name + customers.given_name]
        this.nameFemale = await customers.family_name + customers.given_name
        this.nameFemaleOld = await customers.family_name + customers.given_name
        this.phoneFemale = customers.phone_number;
        this.phoneFemaleOld = customers.phone_number
        this.dataDateArrangement.female_customer_id = customers.id
      }

      this.isFamilyName = false;
    },
    openDialogCV() {
      if (this.dataDateArrangement.option.shift == 1) {
        this.dialogCV = true
      }
    },
    closeDialogCV() {
      this.dialogCV = false
      this.dataDateArrangement.option.shift = 0
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${year}/${month}/${day}`
    },
    formatDateSlash(date) {
      if (!date) return null

      const [year, month, day] = date.split('/')
      return `${year}-${month}-${day}`
    },
    getMonth() {
      return moment(this.value).format("MM")
    },
    validateForm() {
      const validate = this.$refs.form.validate()

      return validate
    },
    validatePhone(e) {
      let validate = false;
      if (e.target.name == 'male') {
        validate = this.$refs.phoneMale.validate()
      } else {
        validate = this.$refs.phoneFemale.validate()
      }

      return validate;
    },
    checkHistory() {
      const validate = this.validateForm()
      if (validate == false) {
          return
      }
      let dataHistory = this.dataDateArrangement
      if (this.historyData?.id) {
        dataHistory.id = this.historyData.id
      }
      this.$axios
        .post("/api/v1/customer/check-history", { dataHistory: dataHistory })
        .then((response) => {
            if (!response.data.canCreate) {
                let  errorMsg = '以下の予定と重複していますが、登録してよろしいですか？';
                if (response.data.conflictingAppointmentRes) {
                  const { kind, targetTime, targetTimeEnd, counselorName, boothNoName, customerName } = response.data.conflictingAppointmentRes;
                  errorMsg += `<p style="font-weight: bold;">${CUSTOMER.EXEC_KIND.getName(kind)}</p>`;
                  errorMsg += `<p>時間：${targetTime.slice(0, -3)}〜${targetTimeEnd.slice(0, -3)}</p>`;
                  errorMsg += `<p>${customerName}</p>`;
                  errorMsg += `<p>担当：${counselorName}</p>`;
                  errorMsg += `<p>ブース：${boothNoName || '--'}</p>`;
                }

                Swal.fire({
                  html: `<div style="text-align: left; color: #000000de; font-size: 14px; font-family: 'Roboto';">${errorMsg}</div>`,
                  confirmButtonText: `<span style="font-size: 14px;">OK</span>`,
                  confirmButtonColor: "#1e88e5",
                  color: '#ffffff',
                  showCancelButton: true,
                  cancelButtonText: `<span style="font-size: 14px;">Cancel</span>`,
                }).then((result) => {
                  if (result.isConfirmed) {
                    this.submit()
                  }
                });
            } else {
              this.submit()
            }
        })
        .catch((error) => {
            console.log(error);
        });
    },
    submit() {
      const validate = this.validateForm()

      if (validate == false) {
        return
      }
      if (this.customerMaleFromHistory) {
        this.dataDateArrangement.male_customer_id = this.customer.id
      }

      if (this.customerFeMaleFromHistory) {
        this.dataDateArrangement.female_customer_id = this.customer.id
      }
      if (!this.dataDateArrangement.female_customer_id) {
        this.dataDateArrangement.female_customer_id = constants.NOT_MEMBER_CUSTOMER
      }

      if (!this.dataDateArrangement.male_customer_id) {
        this.dataDateArrangement.male_customer_id = constants.NOT_MEMBER_CUSTOMER
      }

      if (this.dataDateArrangement.status != this.statusPlan && this.dataDateArrangement.status != this.statusImplementation) {
        this.dataDateArrangement.option.verTel = false
        this.dataDateArrangement.option.follTel = false
        this.dataDateArrangement.option.resTel = false
        this.dataDateArrangement.option.result = null
      }

      if (this.dataDateArrangement.status != this.statusPlan) {
        this.dataDateArrangement.option.verTel = false
      }

      if (this.dataDateArrangement.status != this.statusImplementation) {
        this.dataDateArrangement.option.follTel = false
        this.dataDateArrangement.option.resTel = false
        this.dataDateArrangement.option.result = null
      }

      if (this.dataDateArrangement.status == this.statusImplementation && this.dataDateArrangement.option.result == null) {
        this.dataDateArrangement.option.resTel = false
        this.dataDateArrangement.option.result = null
      }

      if (this.dataDateArrangement.booth_no_id === '') {
        this.dataDateArrangement.booth_no_id = null
      }

      const dataDateArrangement = this.filterDataBody(this.dataDateArrangement)
      // dataDateArrangement.kind = CUSTOMER.EXEC_KIND.VAL.DATE
      if (this.typeSubmit == 'update') {
        this.$axios
          .put(`/api/v1/customer/${this.dataDateArrangement.customer_id}/history/${constants.TYPE_FORM.DATE_INPUT}`, { historyId: this.historyData.id, historyData: dataDateArrangement })
          .then((response) => {
            this.dialogForm = false
            this.$emit('refreshListHistory')
            this.$emit('closeFormDateMatching')
            return response;
          })
          .catch((error) => {
            console.log("Error : " + error);
          });
      } else {
        this.$axios
          .post("/api/v1/customer/date-arrangement", { dataDateArrangement })
          .then((response) => {
            this.dialogForm = false
            this.resetForm()
            this.$emit('refreshCalendar')
            if (this.valueKindForForm) {
              this.$emit('refreshListHistory')
              this.$emit('closeFormDateMatching')
            }
            if (this.isLedgerScreen) {
              this.$emit('refreshLedgerData')
            }
            return response;
          })
          .catch((error) => {
            console.log("Error : " + error);
          });
      }

    },
    apiPhone(e) {
      this.isFamilyName = false;

      const validate = this.validatePhone(e)
      if (validate == false) {
        if (e.target.name == 'male') {
          this.phoneMaleOld = e.target.value
          this.nameMale = ''
          this.nameMaleOld = ''
          this.itemFamilyNameMales = []
        } else {
          this.phoneFemaleOld = e.target.value
          this.nameFemale = ''
          this.nameFemaleOld = ''
          this.itemFamilyNameFemales = []
        }
        return
      }
      let gender = e.target.name == 'male' ? 1 : 2
      if (this.phoneMale == this.phoneFemale) {
        alert('会員番号が重複しています。再度入力してください。')
        if (e.target.name == 'male') {
          this.phoneMale = ''
        } else {
          this.phoneFemale = ''
        }
        return false;
      }
      this.$axios
        .get("/api/v1/customer/phone_number/" + e.target.value + '?gender=' + gender)
        .then((response) => {
          const customer = response.data.customer
          if (customer.id != undefined) {
            if (e.target.name == 'male') {
              this.dataDateArrangement.male_customer_id = customer.id || CUSTOMER.NOT_MEMBER_CUSTOMER
              this.nameMale = customer.family_name + customer.given_name;
              this.nameMaleOld = this.nameMale
              this.itemFamilyNameMales = [this.nameMale]
            } else {
              this.dataDateArrangement.female_customer_id = customer.id || CUSTOMER.NOT_MEMBER_CUSTOMER
              this.nameFemale = customer.family_name + customer.given_name;
              this.nameFemaleOld = this.nameFemale
              this.itemFamilyNameFemales = [this.nameFemale]
            }
          } else {
            alert('対象者が存在しません')
            if (e.target.name == 'male') {
              this.phoneMale = ''
              this.nameMale = ''
              this.itemFamilyNameMales = []
            } else {
              this.phoneFemale = ''
              this.nameFemale = ''
              this.itemFamilyNameFemales = []
            }
            return false;
          }

        })
        .catch((error) => {
          console.log("Error : " + error);
        });
    },
    onDialog() {
      this.$emit('closeMenu')
      this.dialogForm = true
    },
    closeDialog() {
      this.dialogForm = false
      this.resetForm()
      this.$emit('closeFormDateMatching')
    },
    // getTimeAddFromKind(kind) {
    //   this.$axios
    //     .get("/api/v1/date-setting/" + kind)
    //     .then((response) => {
    //       this.addTimeWithKind = response.data.kind.date_add
    //     })
    //     .catch((error) => {
    //       console.log("Error : " + error);
    //     });
    // },
    resetForm() {
      this.$refs.form.resetValidation()
      if (this.typeSubmit == 'update' && this.dataDateArrangement.option.shift == 1) {
        this.dataDateArrangement = {
          kind: null,
          status: this.statusPlan,
          target_date: this.date,
          counselor_id: "",
          target_time: "",
          target_time_end: "",
          male_customer_id: "",
          female_customer_id: "",
          booth_no_id: "",
          note: "",
          type: constants.TYPE_FORM.DATE_INPUT,
          option: {
            // isPay: false,
            result: null,
            verTel: false,
            follTel: false,
            resTel: false,
            shift: 1
          },
        }
        this.phoneMale = ''
        this.nameMale = ''
        this.phoneFemale = ''
        this.nameFemale = ''
      } else if (this.typeSubmit == 'update') {
        if (this.historyData.type == constants.TYPE_FORM.DATE_INPUT && this.valueKindForForm.length == 0) {
          this.dataDateArrangement.kind = this.historyData.kind
          this.dataDateArrangement.target_date = this.formatDateSlash(this.historyData.target_date)
          this.dataDateArrangement.target_time = this.historyData.target_time
          this.dataDateArrangement.target_time_end = this.historyData.target_time_end
          this.dataDateArrangement.customer_id = this.historyData.customer_id
          this.dataDateArrangement.booth_no_id = this.historyData.booth_no_id
          this.dataDateArrangement.counselor_id = this.historyData.counselor_id
          this.dataDateArrangement.note = this.historyData.note
          this.dataDateArrangement.option.counterpart_history_id = this.historyData.option.counterpart_history_id
          this.dataDateArrangement.option.female_customer_id = this.historyData.option.female_customer_id
          this.dataDateArrangement.option.male_customer_id = this.historyData.option.male_customer_id
          this.dataDateArrangement.option.match_reserve_id = this.historyData.option.match_reserve_id
          this.dataDateArrangement.option.shift = this.historyData.option.shift
          this.dataDateArrangement.option.verTel = this.historyData.option.verTel
          this.dataDateArrangement.option.follTel = this.historyData.option.follTel
          this.dataDateArrangement.option.resTel = this.historyData.option.resTel
          this.phoneMale = this.historyData.male_customer.phone_number
          this.nameMale = this.historyData.male_customer.family_name + this.historyData.male_customer.given_name
          this.itemFamilyNameMales = [this.nameMale]
          this.dataDateArrangement.male_customer_id = this.historyData.male_customer.id
          // this.dataDateArrangement.option.isPay = this.historyData.option.isPay
          this.dataDateArrangement.status = this.historyData.status
          this.phoneFemale = this.historyData.female_customer.phone_number
          this.nameFemale = this.historyData.female_customer.family_name + this.historyData.female_customer.given_name
          this.itemFamilyNameFemales = [this.nameFemale]
          this.dataDateArrangement.female_customer_id = this.historyData.female_customer.id
        }
      } else {
        this.dataDateArrangement = {
          kind: null,
          status: this.statusPlan,
          target_date: this.date,
          counselor_id: "",
          target_time: "",
          target_time_end: "",
          male_customer_id: "",
          female_customer_id: "",
          booth_no_id: "",
          note: "",
          type: constants.TYPE_FORM.DATE_INPUT,
          option: {
            // isPay: false,
            result: null,
            verTel: false,
            follTel: false,
            resTel: false,
            shift: 0
          },
        }
        this.phoneMale = ''
        this.nameMale = ''
        this.phoneFemale = ''
        this.nameFemale = ''

        if (this.customerMaleFromHistory) {
          this.itemFamilyNameMales = [this.customer.family_name + this.customer.given_name]
          this.phoneMale = this.customer.phone_number
          this.nameMale = this.customer.family_name + this.customer.given_name
          this.phoneFemale = ''
          this.nameFemale = ''
        }

        if (this.customerFeMaleFromHistory) {
          this.itemFamilyNameFemales = [this.customer.family_name + this.customer.given_name]
          this.phoneFemale = this.customer.phone_number
          this.nameFemale = this.customer.family_name + this.customer.given_name
          this.phoneMale = ''
          this.nameMale = ''
        }
      }

      if (this.valueKindForForm) {
        this.dataDateArrangement.kind = this.valueKindForForm
      }
    },
    changeTimeStart(newStartAt) {
      if (newStartAt != "") {
        const startAt = moment(newStartAt, 'HH:mm')
        this.dataDateArrangement.target_time_end = startAt.isBefore(moment('23:10', 'HH:mm')) ? startAt.add(this.addTimeWithKind, 'minutes').format('HH:mm') : '23:59';
        this.minTime = moment(this.dataDateArrangement.target_time, 'HH:mm').add(30, 'minutes').format('HH:mm')
        this.checkAndSetEndTime(this.dataDateArrangement.target_time, this.addTimeWithKind)
      }
    },
    saveTimeStart() {
      this.changeTimeStart(this.dataDateArrangement.target_time)
      this.$refs.dialog1.save(this.dataDateArrangement.target_time)
    },
    changeKind() {
      if (this.dataDateArrangement.kind != this.kindContract || this.dataDateArrangement.kind != this.kindShiftContract) {
        this.dataDateArrangement.status = this.statusPlan
      }
      this.$axios
        .get("/api/v1/date-setting/" + this.dataDateArrangement.kind)
        .then((response) => {
          this.addTimeWithKind = response.data.kind.date_add
          if (this.dataDateArrangement.target_time != "") {
            this.checkAndSetEndTime(this.dataDateArrangement.target_time, this.addTimeWithKind)
          }
        })
        .catch((error) => {
          console.log("Error : " + error);
        });
    },
    getTimeAddWithKind(kind) {
      if (kind) {
        this.$axios
          .get("/api/v1/date-setting/" + kind)
          .then((response) => {
            this.addTimeWithKind = response.data.kind.date_add
          })
          .catch((error) => {
            console.log("Error : " + error);
          });
      }
    },
    async onCounselorSelected() {
      const validCounselors = this.customer && this.customer.shop_id !== null ? this.validCounselors : this.counselors
      const counselorSelected = validCounselors.find(counselor => counselor.id === this.dataDateArrangement.counselor_id)
      await this.$axios.get(`/api/v1/booth_no/shop/${counselorSelected.shop_id}`)
        .then((response) => {
          this.validBoothNos = response.data.booth_nos;
          if (response.data.booth_nos.length > 0 && response.data?.booth_nos[0]?.shop_id != counselorSelected.shop_id) {
            this.dataDateArrangement.booth_no_id = "";
          }
        })
        .catch((error) => {
          console.log("Error : " + error);
        });
    },
    getCO(customer) {
      this.$axios
        .get(`/api/v1/user/counselors?shop_id=${customer.shop_id}`)
        .then((response) => {
          this.validCounselors = response.data.counselors
        })
        .catch((error) => {
          console.log("Error : " + error)
        })
    },
    getCounselorByCustomerShopId(customerId) {
      if (customerId) {
        this.$axios
          .get(`/api/v1/customer/${customerId}`)
          .then((response) => {
            const customer = response.data.customer
            if (customer.id != undefined) {
              this.getCO(customer)
            } else {
              alert('対象者が存在しません')
              this.validCounselors = []
              this.validBoothNos = []
              return false
            }
          })
          .catch((error) => {
            console.log("Error : " + error)
          })
      }
    },
    filterDataBody(data) {
      return Object.entries(data)
        .reduce((items, [key, value]) => {
          if (value !== null) {
            items[key] = value;
          }
          return items;
        }, {});
    },
    timeToMinutes(time) {
      const [hours, minutes] = time.split(':').map(Number)
      return hours * 60 + minutes
    },
    minutesToTime(minutes) {
      const hours = Math.floor(minutes / 60)
      const mins = minutes % 60
      return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`
    },
    checkAndSetEndTime(targetTime, addTimeWithKind) {
      let targetTimeEndMinutes = this.timeToMinutes(targetTime) + addTimeWithKind

      // Check if exceeds 23:59 (1439 minutes)
      if (targetTimeEndMinutes > 1439) {
        targetTimeEndMinutes = 1439
      }

      this.dataDateArrangement.target_time_end = this.minutesToTime(targetTimeEndMinutes)
    },
    openMemoModal() {
      if (this.suppressMemoOpen) {
        return;
      }
      this.memoContent = this.dataDateArrangement.note || '';
      this.memoDialog = true;
      this.$nextTick(() => {
        if (this.$refs.memoTextarea && this.$refs.memoTextarea.$el) {
          const ta = this.$refs.memoTextarea.$el.querySelector('textarea');
          ta && ta.blur();
        }
        if (this.$refs.memoModalTextarea) {
          this.$refs.memoModalTextarea.focus();
        }
        this.adjustMemoModalSize();
      });
    },
    confirmMemoModal() {
      this.dataDateArrangement.note = this.memoContent;
      this.suppressMemoOpen = true;
      this.memoDialog = false;
      this.$nextTick(() => {
        if (this.$refs.memoTextarea && this.$refs.memoTextarea.$el) {
          const ta = this.$refs.memoTextarea.$el.querySelector('textarea');
          ta && ta.blur();
        }
        setTimeout(() => {
          this.suppressMemoOpen = false;
        }, 200);
      });
    },
    cancelMemoModal() {
      this.suppressMemoOpen = true;
      this.memoDialog = false;
      this.memoContent = this.dataDateArrangement.note || '';
      this.$nextTick(() => {
        if (this.$refs.memoTextarea && this.$refs.memoTextarea.$el) {
          const ta = this.$refs.memoTextarea.$el.querySelector('textarea');
          ta && ta.blur();
        }
        setTimeout(() => {
          this.suppressMemoOpen = false;
        }, 200);
      });
    },
    adjustMemoModalSize() {
      this.$nextTick(() => {
        const textarea = this.$refs.memoModalTextarea && this.$refs.memoModalTextarea.$el
          ? this.$refs.memoModalTextarea.$el.querySelector('textarea')
          : null;
        if (!textarea) return;

        const MIN_HEIGHT = 120; // px (5 rows * ~24)
        const MAX_HEIGHT = 360; // px (15 rows * ~24)

        textarea.style.height = 'auto';
        const newHeight = Math.max(MIN_HEIGHT, Math.min(textarea.scrollHeight, MAX_HEIGHT));
        textarea.style.height = newHeight + 'px';
      });
    },
    checkMemoContentAndOpenModal(content, maxLines = 3) {
      if (!content || !content.trim()) return;
      
      const explicitLineCount = content.split(/\r?\n/).length;
      
      if (explicitLineCount > maxLines) {
        this.openMemoModal();
        return;
      }
      
      this.$nextTick(() => {
        const textarea = this.$refs.memoTextarea && this.$refs.memoTextarea.$el
          ? this.$refs.memoTextarea.$el.querySelector('textarea')
          : null;
        
        if (textarea) {
          const originalHeight = textarea.style.height;
          textarea.style.height = 'auto';
          
          const lineHeight = parseInt(window.getComputedStyle(textarea).lineHeight) || 24;
          const visualLines = Math.ceil(textarea.scrollHeight / lineHeight);
          
          textarea.style.height = originalHeight;
          
          if (visualLines > maxLines) {
            this.openMemoModal();
          }
        }
      });
    },
    onMemoInput(val) {
      const content = typeof val === 'string' ? val : (this.dataDateArrangement.note || '');
      this.checkMemoContentAndOpenModal(content, 3);
    },
    onMemoClick() {
      const content = this.dataDateArrangement.note || '';
      this.checkMemoContentAndOpenModal(content, 3);
    },
  }
}
</script>

<style scoped>
.body-content-dialog {
  height: calc(100vh - 210px);
  overflow-y: auto;
}

.container.grid-list-md .layout .flex {
  padding: 4px 12px;
}

/* Clickable textarea styling */
.clickable-textarea {
  cursor: pointer;
}

.memo-modal-textarea ::v-deep .v-text-field__slot textarea {
  min-height: 120px !important;
  max-height: unset !important;
  line-height: 24px !important;
  padding: 12px !important;
  font-size: 14px !important;
  overflow-y: auto !important;
  resize: vertical !important;
}
</style>
